import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { MainSection, SectionTitle } from "../components/common_components/Layout";
import HeaderResearcherMission from "../components/common_components/HeaderResearcherMission";
import MissionOverview from "../components/missions_components/MissionOverview";
import UpcomingSessions from "../components/missions_components/sessions_components/UpcomingSessions";
import CompletedSessions from "../components/missions_components/sessions_components/CompletedSessions";
import ReviewUsers from "../components/missions_components/sessions_components/ReviewUsers";
import ReviewUserPage from "../components/missions_components/sessions_components/ReviewUserPage";
import SessionPage from "../components/missions_components/sessions_components/SessionPage";
import SchedulingPage from "../components/missions_components/sub_page_components/SchedulingPage";
import RequirementsPage from "../components/missions_components/sub_page_components/RequirementsPage";
// import ScreenerCreate from "../components/missions_components/sub_page_components/ScreenerCreate";
import SurveyCreate from "../components/missions_components/sub_page_components/SurveyCreate";
import SurveyResponses from "../components/missions_components/sessions_components/SurveyResponses";
import PricingPage from "../components/missions_components/sub_page_components/PricingPage";

// Api Calls
import MissionAPI from "../api/api_calls/MissionAPI";


function Mission(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingMission, setLoadingMission] = useState(true);

    const [mission, setMission] = useState({});



    useEffect(() => {
        async function getMissionDetails() {
            const result = await MissionAPI.show(missionId, navigate);

            if (result.success) {
                setMission(result.mission)
                setLoadingMission(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }
        getMissionDetails();
    }, []);

    return (
        <>
            <HeaderResearcherMission missionStatus={mission.status} missionName={mission.name} />
            <Routes>
                <Route path="" element={<MissionOverview />} /> {/* Mission Overview Page */}
                <Route path="scheduling" element={<SchedulingPage />} /> {/* Scheduling */}
                <Route path="requirements" element={<RequirementsPage missionStatus={mission.status} />} /> {/* Requirements */}
                <Route path="screener" element={<SurveyCreate missionStatus={mission.status} isScreener={true} />} /> {/* Screener */}
                <Route path="survey" element={<SurveyCreate missionStatus={mission.status} isScreener={false} />} /> {/* Survey */}
                <Route path="pricing" element={<PricingPage missionStatus={mission.status} />} /> {/* Pricing */}
                <Route path="upcomingsessions" element={<UpcomingSessions />} />  {/* Upcoming Sessions LIst*/}
                <Route path="reviewusers/*" >
                    <Route path=":appId" element={<ReviewUserPage />} />
                    <Route index element={<ReviewUsers />} />  {/* Index - REview all sessions*/}
                </Route>
                <Route path="sessions/*"  >
                    <Route path=":sessionId" element={<SessionPage />} />  {/* Individual Session*/}
                    <Route index element={<CompletedSessions />} />  {/* Index - Past Sessions List*/}
                </Route>
                <Route path="responses" element={<SurveyResponses />} />  {/* Survey Responses*/}
            </Routes>
        </>

    )

}



export default Mission;